// extracted by mini-css-extract-plugin
module.exports = {"error":"FabricError_error__02geD","dashboard_button":"FabricError_dashboard_button__2aOv7","spacer":"FabricError_spacer__BXWXh","error_content":"FabricError_error_content__akTsP"};